const attachBlob = (blob, originalFile, target) => {
  const compressedFile = new File(
    [blob],
    originalFile.name,
    { type: originalFile.type, lastModified: new Date().getTime() },
  );
  const container = new DataTransfer();
  container.items.add(compressedFile);
  // Replace the original image file with the new cropped image file

  target.files = container.files;
};

const compressImage = (img, originalFile, target, fileMaxSize) => {
  const canvas = document.createElement('canvas');
  const fileSize = originalFile.size;

  const quality = fileMaxSize < fileSize ? fileMaxSize / (fileSize * 2) : undefined;

  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, img.width, img.height);

  // get the data from canvas as quality% JPG (can be also PNG, etc.)
  canvas.toBlob(blob => attachBlob(blob, originalFile, target), originalFile.type, quality);
};

const compress = (input, originalFile, maxSize) => {
  const maxSizeValue = parseInt(maxSize, 10);
  if (maxSizeValue > originalFile.size) return;

  window.URL = window.URL || window.webkitURL;
  const blobURL = window.URL.createObjectURL(originalFile);
  const image = new Image();
  image.src = blobURL;
  image.onload = () => {
    compressImage(image, originalFile, input, maxSizeValue);
  };
};

export default compress;
